import React from 'react';
import { Header } from '../../../components/ToxicDetector/Header';
import { HeroSection } from '../../../components/ToxicDetector/HeroSection';
import { TrustSection } from '../../../components/ToxicDetector/TrustSection';
import { FeaturesSection } from '../../../components/ToxicDetector/FeaturesSection';
import { GuaranteesSection } from '../../../components/ToxicDetector/GuaranteesSection';
import { ToolsSection } from '../../../components/ToxicDetector/ToolsSection';
import { ComparisonSection } from '../../../components/ToxicDetector/ComparisonSection';
import { PricingSection } from '../../../components/ToxicDetector/PricingSection';
import { FAQSection } from '../../../components/ToxicDetector/FAQSection';
import { CTASection } from '../../../components/ToxicDetector/CTASection';
import { Footer } from '../../../components/ToxicDetector/Footer';
import { MetaTags } from '../../../components/SEO/MetaTags';
import { PromoBanner } from '../../../components/Notifications/PromoBanner';
import { GoogleTranslateWidget } from '../../../components/GoogleTranslateWidget';
export function LandingPageID() {
  const alternateUrls = [{
    lang: 'en',
    url: 'https://toxicdetector.com/'
  }, {
    lang: 'pt-BR',
    url: 'https://toxicdetector.com/pt/'
  }, {
    lang: 'es-MX',
    url: 'https://toxicdetector.com/es/'
  }, {
    lang: 'ja',
    url: 'https://toxicdetector.com/ja/'
  }, {
    lang: 'ko',
    url: 'https://toxicdetector.com/ko/'
  }, {
    lang: 'de',
    url: 'https://toxicdetector.com/de/'
  }, {
    lang: 'fr',
    url: 'https://toxicdetector.com/fr/'
  }, {
    lang: 'hi',
    url: 'https://toxicdetector.com/hi/'
  }, {
    lang: 'id',
    url: 'https://toxicdetector.com/id/'
  }];
  return <>
      <MetaTags title="ToxicDetector: Analisis Hubungan AI | Deteksi Pola Beracun & Gaslighting" description="Cari tahu apakah mantan Anda masalahnya. Unggah obrolan Anda ke AI ToxicDetector untuk analisis instan dan rahasia tentang manipulasi, gaslighting, dan bendera merah. Mulai pemindaian gratis hari ini." keywords="analisis hubungan AI, deteksi pola beracun, detektor gaslighting, mantan beracun, pemeriksa manipulasi, toksisitas hubungan, pemindai teks AI" canonical="https://toxicdetector.com/id" language="id" alternateUrls={alternateUrls} data-id="element-7285" />
      <GoogleTranslateWidget data-id="element-7286" />
      <PromoBanner data-id="element-7287" />
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-7288">
        <Header data-id="element-7289" />
        <main data-id="element-7290">
          <HeroSection h1Override={<>
                Otak Anda{' '}
                <span className="relative inline-block" data-id="element-7292">
                  <span className="relative z-10 text-transparent bg-clip-text bg-gradient-to-b from-gray-200 to-gray-500" data-id="element-7293">
                    Berbohong
                  </span>
                  <span className="absolute top-1/2 left-0 w-full h-[4px] md:h-[6px] bg-[#FF0000] -translate-y-1/2 rotate-[-2deg]" data-id="element-7294" />
                </span>{' '}
                Kepada Anda.
                <br data-id="element-7295" />
                <span className="text-[#FF0000] drop-shadow-[0_0_30px_rgba(255,0,0,0.4)]" data-id="element-7296">
                  AI Kami Tidak.
                </span>
              </>} data-id="element-7291" />
          <TrustSection data-id="element-7297" />
          <FeaturesSection data-id="element-7298" />
          <GuaranteesSection data-id="element-7299" />
          <ToolsSection data-id="element-7300" />
          <ComparisonSection data-id="element-7301" />
          <PricingSection data-id="element-7302" />
          <FAQSection data-id="element-7303" />
          <CTASection data-id="element-7304" />
        </main>
        <Footer data-id="element-7305" />
      </div>
    </>;
}